import React from "react";
import { Building2 } from "lucide-react";

function ClientLogo({ brand }) {
    const initials = brand.name
        .split(" ")
        .map((w) => w[0])
        .slice(0, 2)
        .join("")
        .toUpperCase();

    const inner = (
        <div className="group relative h-24 lg:h-28 flex items-center justify-center px-6 border border-white/5 bg-ink-800/30 hover:bg-ink-800/60 hover:border-brand/40 transition-all overflow-hidden">
            {brand.logo_url ? (
                <img
                    src={brand.logo_url}
                    alt={brand.name}
                    loading="lazy"
                    decoding="async"
                    className="max-h-12 max-w-[140px] object-contain opacity-50 grayscale group-hover:opacity-100 group-hover:grayscale-0 transition-all duration-500"
                    onError={(e) => {
                        e.currentTarget.style.display = "none";
                        e.currentTarget.nextSibling.style.display = "flex";
                    }}
                />
            ) : null}
            <div
                style={{ display: brand.logo_url ? "none" : "flex" }}
                className="items-center justify-center w-full h-full"
            >
                <span className="font-display text-2xl text-white/70 group-hover:text-white tracking-tight transition-colors text-center px-2">
                    {brand.name}
                </span>
            </div>
            <span className="absolute bottom-2 left-1/2 -translate-x-1/2 mono-label opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap text-xs">
                {brand.name}
            </span>
        </div>
    );

    if (brand.website) {
        return (
            <a href={brand.website} target="_blank" rel="noreferrer" data-testid={`client-${brand.name.toLowerCase().replace(/\s|\./g, "-")}`}>
                {inner}
            </a>
        );
    }
    return <div data-testid={`client-${brand.name.toLowerCase().replace(/\s|\./g, "-")}`}>{inner}</div>;
}

export default function Clients({ brands = [] }) {
    const clients = brands.filter((b) => b.type === "client");
    if (clients.length === 0) return null;

    return (
        <section id="clients" data-testid="clients-section" className="relative py-24 md:py-32 border-t border-white/5">
            <div className="max-w-7xl mx-auto px-6 lg:px-10">
                <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-12">
                    <div>
                        <div className="mono-label mb-4 flex items-center gap-2">
                            <Building2 size={11} className="text-brand" /> GROWING TOGETHER
                        </div>
                        <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl text-white leading-[0.95] tracking-tighter">
                            Transforming ideas into resilient <span className="text-brand">systems</span>.
                        </h2>
                    </div>
                    <p className="text-ink-200 max-w-md">
                        Collaborating across enterprise banking, digital commerce, and public institutions to engineer resilient digital foundations that scale with your vision.
                    </p>
                </div>

                <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 -m-px">
                    {clients.map((b) => (
                        <ClientLogo key={b.id} brand={b} />
                    ))}
                </div>
            </div>
        </section>
    );
}
